export const MODIFY_KEYS_PK = 'MODIFY_KEYS_PK';

export function modifyKeysPK(keysPK){
    return{
        type: MODIFY_KEYS_PK,
        mainState: {
            keysPK: keysPK
        }
    }
}